import React, { FC } from 'react'
import classnames from 'classnames'
import style from './FormTitle.module.css'

interface IFormTitleProps {
  text: string
  className?: string
}

export const FormTitle: FC<IFormTitleProps> = ({ text, className }) => {
  const classNames = classnames(style.title, className)

  return <h1 className={classNames}>{text}</h1>
}

FormTitle.displayName = 'FormTitle'
